import { FiPlay, FiPrinter } from "react-icons/fi";
import { brandGradient, classNames } from "./utils";

export default function HeaderBar() {
  return (
    <header className="relative overflow-hidden">
      <div className={classNames(brandGradient, "h-1 w-full")} />
      <div className="px-4 sm:px-6 lg:px-10 py-6 bg-white dark:bg-slate-900">
        <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
          <div className="flex-1">
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white">
              Tutoriel • MonAppliClub
            </h1>
            <p className="text-slate-600 dark:text-slate-300 mt-1">
              Guide pas à pas pour bien débuter et tout retrouver facilement.
            </p>
          </div>
          <div className="flex items-center gap-2">
            {/* <a
              href="#demo-video"
              className="inline-flex items-center gap-2 rounded-xl px-4 py-2 border border-slate-300 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"
            >
              <FiPlay /> Voir la vidéo de démo
            </a> */}
            {/* <button
              onClick={() => window.print()}
              className="inline-flex items-center gap-2 rounded-xl px-4 py-2 bg-slate-900 text-white dark:bg-white dark:text-slate-900 hover:opacity-90"
            >
              <FiPrinter /> Imprimer / PDF
            </button> */}
          </div>
        </div>
      </div>
    </header>
  );
}
